<h2 mat-dialog-title>Add User to Company</h2>
@if (!isLoading) {
    <div class="w-100 d-flex justify-content-center aligh-items-center">
        <section class="user-info" aria-label="Selected user info">
            <header class="user-header">
                <div class="avatar" aria-hidden="true">
                    {{ (data.name || data.email || 'U').charAt(0) | uppercase }}
                </div>
                <div class="meta">
                    <div class="name text-color-primary">{{ data.name }}</div>
                    <div class="email d-flex justify-content-center align-items-start">
                        <mat-icon inline class="icon-16 text-color-primary">mail</mat-icon>
                        <span class="email-text text-color-primary">{{ data.email }}</span>
                    </div>
                </div>
            </header>
        </section>
    </div>
    

    @if(!companiesLoading){
        <div class="table-wrapper">
            <table mat-table [dataSource]="companyDataSource" class="mat-elevation-z2">

                <ng-container matColumnDef="company_id">
                    <th mat-header-cell *matHeaderCellDef>ID</th>
                    <td mat-cell *matCellDef="let element">{{ element.id }}</td>
                </ng-container>

                <ng-container matColumnDef="company_name">
                    <th mat-header-cell *matHeaderCellDef>Name</th>
                    <td mat-cell *matCellDef="let element">{{ element.name }}</td>
                </ng-container>
        
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef>Actions</th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-icon-button color="warn" aria-label="Delete company" (click)="onDeleteCompany(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </ng-container>
        
                <tr mat-header-row *matHeaderRowDef="companyDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: companyDisplayedColumns"></tr>
            </table>
        </div>
    }@else{
        <div class="d-flex justify-content-center align-items-center">
            <mat-progress-spinner class="bright-spinner" mode="indeterminate"></mat-progress-spinner>
        </div>
    }

    

    <form [formGroup]="addUserCompanyForm" novalidate (keydown.enter)="$event.preventDefault()">
        <mat-dialog-content class="mat-typography">
            <div class="form-grid">
                <search-company class="full" appearance="fill" [searchCompanyForm]="addUserCompanyForm"></search-company>
            </div>
        </mat-dialog-content>

        <mat-dialog-actions align="end">
            <button mat-button mat-dialog-close>Cancel</button>
            <button mat-flat-button color="primary" [disabled]="addUserCompanyForm.invalid" (click)="onAddUserCompany()">Save</button>
        </mat-dialog-actions>
    </form>
}@else{
    <div class="d-flex justify-content-center align-items-center">
        <mat-progress-spinner class="bright-spinner" mode="indeterminate"></mat-progress-spinner>
    </div>
}
